import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import useAuth from '../auth/useAuth';
import BrandLogo from '../components/BrandLogo';
import TwoFactorSettings from '../components/TwoFactorSettings';
import Button from '../components/ui/Button';

/**
 * Where an account lands that the platform requires 2FA of and that has none
 * yet (auth/TwoFactorGate.js): the setup, and signing out - nothing else.
 */
function TwoFactorSetup() {
  const { t } = useTranslation();
  const { user, refreshUser, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  if (!user?.twoFactorSetupRequired) {
    return <Navigate to="/account" replace />;
  }

  async function finished() {
    await refreshUser();
    const from = location.state?.from;
    navigate(from ? `${from.pathname}${from.search ?? ''}${from.hash ?? ''}` : '/', { replace: true });
  }

  return (
    <main className="login-page">
      <section className="login-card two-factor-required" aria-labelledby="two-factor-required-title">
        <div className="login-brand">
          <BrandLogo variant="mark" />
        </div>

        <div className="login-heading">
          <h1 id="two-factor-required-title">{t('twoFactorRequired.title')}</h1>
          <p>{t('twoFactorRequired.description')}</p>
        </div>

        <TwoFactorSettings enabled={false} required onChanged={finished} />

        <Button variant="text" onClick={() => logout()}>
          {t('twoFactorRequired.logout')}
        </Button>
      </section>
    </main>
  );
}

export default TwoFactorSetup;
